import ListStoresPage from './ListStoresPage';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetMerchantByIdQuery } from '../../merchants/merchant.api-slice';
import { useParams } from 'react-router-dom';

const ListStoresForMerchant: React.FC = () => {
  const { id } = useParams();
  const { data } = useGetMerchantByIdQuery(id ?? skipToken);

  return <ListStoresPage merchant={data} scope={'merchant'} />;
};

export default ListStoresForMerchant;
